import React from 'react'

const Contact = () => {
    return (
        <div>
            Hello, This is Contact
        </div>
    )
}

export default Contact;